import Q = require("q");
import Utils_Core = require("VSS/Utils/Core");
import Utils_String = require("VSS/Utils/String");
import { IProcess } from "WorkCustomization/Scripts/Contracts/Process";
import { ProcessMigrationModel } from "WorkCustomization/Scripts/Contracts/Projects";
import { WebAccessBoardsWITDataSource } from "Presentation/Scripts/TFS/MVCToDataProviderDataSources/MVCToDataProviderDataSource";
import { IRouteParams, IDataSourceResponse } from "Presentation/Scripts/TFS/MVCToDataProviderDataSources/WITDataSource";
import { PageDataService } from "WorkCustomization/Scripts/WebApi/PageDataService";
import * as VSSService from "VSS/Service";

export function beginMigrateProjectsAsync(migratingProjects: ProcessMigrationModel[]): IPromise<IProcess[]> {
    let deferred: Q.Deferred<IProcess[]> = Q.defer<IProcess[]>();
    const routeParams: IRouteParams = { controller: "process", action: "MigrateProjectsProcess" };
    const pageDataSvc = VSSService.getService(PageDataService);
    const dataSource: WebAccessBoardsWITDataSource = new WebAccessBoardsWITDataSource();
    let requestProperties: any;

    if (dataSource.isDataProviderEnabled(routeParams)) {
        requestProperties = { migratingProjects: migratingProjects };
    }
    else {
        requestProperties = { migratingProjects: Utils_Core.stringifyMSJSON(migratingProjects) }
    }

    dataSource.postDataAsync<any[]>(routeParams, requestProperties)
        .then((response: IDataSourceResponse<any[]>) => {
            if (response.data && response.data.length > 0) {
                let htmlMessage = "";
                for (let entry of response.data) {
                    if (entry.exception != null && entry.exception.message != null) {
                        htmlMessage += Utils_String.htmlEncode(entry.exception.message) + "<br />"; // we don't trust server message, so encode it
                    }
                }

                if (htmlMessage.length > 0) {
                    deferred.reject({ htmlMessage: htmlMessage });
                    return;
                }
            }

            pageDataSvc.beginReloadPageData()
                .then(data => {
                    deferred.resolve(data.processes);
                }, deferred.reject);
        }, deferred.reject);

    return deferred.promise;
}
